<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import Cashback from '~/components/modal-windows/Cashback.vue'
import constants from '~/constants'
import helpers from '~/helpers'
import formatter from '~/helpers/formatter'

const props = withDefaults(
  defineProps<{
    cashbackInPoints?: number | null
    isSupermins?: boolean
    showHelpIcon?: boolean
    showUnits?: boolean
  }>(),
  { cashbackInPoints: null, isSupermins: false, showHelpIcon: true, showUnits: true }
)

async function openCashbackModalWindow (): Promise<void> {
  await useModal({ component: Cashback, attrs: { isSupermins: props.isSupermins } }).open()
}
</script>

<template>
  <span
    v-if="typeof cashbackInPoints === 'number'"
    class="cashback-area inline-flex items-baseline text-main-green"
    :class="{ 'supermins': isSupermins }"
    :title="`Баллы ${isSupermins ? 'Supermins' : 'iTAB Плюс'}`"
  >
    <SvgIcon class="bolt-icon" name="outlined/bolt" />

    <span>
      <template v-if="showUnits">
        {{ formatter.formatPrice(cashbackInPoints) }}&nbsp;{{ helpers.getDeclension(cashbackInPoints, constants.wordForms.point) }}
      </template>
      <template v-else>
        {{ formatter.formatPrice(cashbackInPoints) }}
      </template>
    </span>

    <SvgIcon
      v-if="showHelpIcon"
      class="ml-1"
      name="outlined/help-outline"
      @click="openCashbackModalWindow"
    />
  </span>
</template>

<style lang="scss" scoped>
@use 'assets/css/variables';

.cashback-area {
  &.supermins {
    color: variables.$main-purple-color;
  }

  svg {
    align-self: center;

    &.bolt-icon {
      margin-right: 2px;
    }

    &.help-icon:hover {
      color: variables.$main-blue-color;
      cursor: pointer;
    }
  }
}
</style>
